const userActionTypes = {
  // -------------------User----------------
  FETCH_USER: "FETCH USER",
  LOGOUT_USER: "LOGOUT USER",
  LOGIN_SUCCESS: "LOGIN SUCCESS",
  LOGIN_WITH_GOOGLE: "LOGIN WITH GOOGLE",
  //----------------Plaid Token-------------
  GET_ACCESS_TOKEN: "GET ACCESS TOKEN",
  // GET_ACCOUNT: "GET BANK ACCOUNTS",
  //----------------Expenses-----------------
  // GET_EXPENSES: "GET EXPENSES",
  // UPDATE_A_EXPENSES: "UPDATE A EXPENSE",
  // CREATE_OR_UPDATE_EXPENSES: "CREATE OR UPDATE EXPENSES",
  // ADD_EXPENSE: "ADD EXPENSE",
  // DELETE_EXPENSE: "DELETE EXPENSE",
  // -----------------Budget---------------
  // ADD_BUDGET: "ADD BUDGET",
  // GET_BUDGET: "GET BUDGET",
  // GET_BUDGET_NAMES: "GET BUDGET NAMES",
  // DELETE_A_BUDGET: "DELETE A BUDGET",
  // GET_BUDGET_TOTAL_AMOUNT: "GET BUDGET TOTAL AMOUNT",
  // GET_BUDGET_EXPENSE_TOTAL_AMOUNT: "GET BUDGET EXPENSE TOTAL AMOUNT",
  // ----------------------Transaction------------------
  // GET_TRANS: "GET TRANSACTIONS",
};

export default userActionTypes;
